import React from "react"
import { useTranslation } from "react-i18next"

import { Content, Description } from "pages/static/elements"
import Title from "components/ui/Title"

const NotFound = () => {
  const { t } = useTranslation()

  return (
    <Content data-testid="not-found-page">
      <Title>{t("pages.not_found.title")}</Title>
      <Description>{t("pages.not_found.description")}</Description>
    </Content>
  )
}

export default NotFound
